import Login from './components/auth/Login'
import TermReport from './components/TermReport'

//import Logout from './components/auth/Logout'

const routes = [
  { 
      path: '/',
      name: 'login', 
      component: Login,
      meta: {
        requiresVisitor: true,
      }
  },  
  {
    path: '/term-report',
    name: 'termReport',
    component: TermReport,
    meta: {
      requiresAuth: true
    }
  },
  // {
  //   path: '*',
  //   component: NotFoundComponent
  // }  
]

export default routes